  import { createContext, useState, useEffect, useRef, useCallback } from "react";
  import moment from "moment";
  import { useCookies } from "react-cookie";

  import ReportsService from "../services/reports.service";

  export const ReportsContext = createContext();
  export const ReportsProvider = ({ children }) => {
    const [startDate, setStartDate] = useState(
      moment().add(-7, "days").format("YYYY-MM-DD"),
    );
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [loading, setLoading] = useState(0);
    const [overview, setOverview] = useState({});
    const [sms, setSms] = useState([]);
    const [email, setEmail] = useState([]);
    const [guestbook, setGuestbook] = useState([]);
    const [rental, setRental] = useState([]);
    const [guide, setGuide] = useState([]);
    const [history, setHistory] = useState([]);
    const [macros, setMacros] = useState([]);
    const [fivestar, setFivestar] = useState([]);
    const [surveyReport, setSurveyReport] = useState({});
    const [extendStay, setExtendStay] = useState([]);
    const [guestChecks, setGuestChecks] = useState([]);
    const [extendstayChecks, setExtendstayChecks] = useState([])
    const [webchats, setWebChats] = useState([]);
    const [extras, setExtras] = useState([]);
    const [guestbookByDevice, setGuestbookByDevice] = useState([]);
    const [guestbookByGuest, setGuestbookByGuest] = useState([]);
    const [chatbotLogs, setChatbotLogs] = useState({ total: 0, paginated: [] });
    const [replyLogs, setReplyLogs] = useState({ total: 0, paginated: [] });    
    const [smartLockLogs, setSmartLockLogs] = useState({ total: 0, paginated: [] });
    const [active, setActive] = useState(0);
    const [filter, setFilter] = useState("");
    const [page, setPage] = useState(0);
    const [orderDetails, setOrderDetails] = useState({});
    const [incomeByItem, setIncomeByItem] = useState({});
    const [bookingSourceMapping, setBookingSourceMapping] = useState({ total: 0, paginated: [] });
    const [bookingIntelligence, setBookingIntelligence] = useState([]);
    const [communicationIntelligence, setCommunicationIntelligence] = useState({ messages: [], automations: [] });
    const [auditReservations, setAuditReservations] = useState([]);
    const [messageAudit, setMessageAudit] = useState([]);
    const overviewRequestId = useRef(0);
    const bookingIntelligenceRequest = useRef({
      key: null,
      data: [],
      hasLoaded: false,
      promise: null,
    });
    const communicationIntelligenceRequest = useRef({
      key: null,
      data: { messages: [], automations: [] },
      hasLoaded: false,
      promise: null,
    });

    const initReports = () => {
      updateRange(
        moment().subtract(7, "day").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      );
    };

    const updateRange = async (startDate, endDate) => {
      setStartDate(moment(startDate).format("YYYY-MM-DD"));
      setEndDate(moment(endDate).format("YYYY-MM-DD"));
    };

    const getAutomatedSms = async (
      start,
      end,
      page = 0,
      per = 20,
      filter = "",
    ) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setSms(
        await ReportsService.getAutomated(
          "sms",
          start,
          end,
          page,
          per,
          filter,
        ).then((response) => response.data),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getAutomatedEmail = async (
      start,
      end,
      page = 0,
      per = 20,
      filter = "",
    ) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setEmail(
        await ReportsService.getAutomated(
          "email",
          start,
          end,
          page,
          per,
          filter,
        ).then((response) => response.data),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getGuide = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setGuide(
        await ReportsService.getDestinations(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getRental = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setRental(
        await ReportsService.getRental(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getFiveStar = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setFivestar(
        await ReportsService.getFiveStar(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getSurveyReport = async (surveyId, start, end) => {
      if (!surveyId || !start || !end) {
        setSurveyReport({});
        return {};
      }

      setLoading((loadingStatus) => loadingStatus + 1);
      try {
        const data = await ReportsService.getSurveyReport(surveyId, start, end).then(
          (response) => response.data,
        );
        setSurveyReport(data || {});
        return data || {};
      } finally {
        setLoading((loadingStatus) => loadingStatus - 1);
      }
    };

    const getExtendStay = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setExtendStay(
        await ReportsService.getExtendStay(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getGuestChecks = async (
      start,
      end,
      page = 0,
      per = 20,
      filter = "",
    ) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setGuestChecks(
        await ReportsService.getGuestChecks(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getExtendStayChecks = async (
      start,
      end,
      page = 0,
      per = 20,
      filter = "",
    ) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setExtendstayChecks(
        await ReportsService.getExtendStayChecks(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getWebChat = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setWebChats(
        await ReportsService.getWebChat(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getGuestbook = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setGuestbook(
        await ReportsService.getGuestBooks(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getGuestBooksByDevice = async (
      start,
      end,
      page = 0,
      per = 20,
      filter = "",
    ) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setGuestbookByDevice(
        await ReportsService.getGuestBooksByDevice(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getGuestBooksByGuest = async (
      start,
      end,
      page = 0,
      per = 20,
      filter = "",
    ) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setGuestbookByGuest(
        await ReportsService.getGuestBooksByGuest(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getHistory = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setHistory(
        await ReportsService.getHistory(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getOverview = async (start, end) => {
      const requestId = overviewRequestId.current + 1;
      overviewRequestId.current = requestId;
      setLoading((loadingStatus) => loadingStatus + 1);
      try {
        const data = await ReportsService.getOverviews(start, end).then(
          (response) => response.data,
        );
        if (overviewRequestId.current === requestId) {
          setOverview(data);
        }
      } finally {
        setLoading((loadingStatus) => loadingStatus - 1);
      }
    };

    const getMacros = async (opts = {}) => {
      setLoading((prev) => prev + 1);
      try {
        const data = await ReportsService.getMacros(opts).then((response) => response.data);
        setMacros(data);
        return data;
      } finally {
        setLoading((prev) => prev - 1);
      }
    };

    const getExtras = async (start, end, page = 0, per = 20) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setExtras(
        await ReportsService.getExtras(start, end, page, per).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getChatbotLogs = async (start, end, page = 0, per = 20) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setChatbotLogs(
        await ReportsService.getChatbotLogs(start, end, page, per).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getReplyLogs = async (start, end, page = 0, per = 20) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setReplyLogs(
        await ReportsService.getReplyLogs(start, end, page, per).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getSmartLockLogs = async (start, end, page = 0, per = 20, filter = "") => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setSmartLockLogs(
        await ReportsService.getSmartLockLogs(start, end, page, per, filter).then(
          (response) => response.data,
        ),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getOrderDetails = async (start, end, page = 0, per = 20) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setOrderDetails(
        await ReportsService.getOrderDetails(start, end, page, per).then((response) => response.data),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getIncomeByItem = async (start, end, page = 0, per = 20) => {
      setLoading((loadingStatus) => loadingStatus + 1);
      setIncomeByItem(
        await ReportsService.getIncomeByItem(start, end, page, per).then((response) => response.data),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getBookingSourceMapping = async (page = 0, per = 20) => {
      setLoading((prev) => prev + 1);
      setBookingSourceMapping(
        await ReportsService.getBookingSourceMapping(page, per).then((response) => response.data),
      );
      setLoading((loadingStatus) => loadingStatus - 1);
    };

    const getBookingIntelligence = useCallback(async (start, end) => {
      if (!start || !end) return [];

      const requestKey = `${moment(start).format("YYYY-MM-DD")}:${moment(end).format("YYYY-MM-DD")}`;
      const currentRequest = bookingIntelligenceRequest.current;

      if (currentRequest.key === requestKey) {
        if (currentRequest.promise) {
          return currentRequest.promise;
        }

        if (currentRequest.hasLoaded) {
          return currentRequest.data;
        }
      }

      setLoading((prev) => prev + 1);
      const requestPromise = ReportsService.getBookingIntelligence(start, end).then(
        (response) => response.data?.reservations || [],
      );

      bookingIntelligenceRequest.current = {
        key: requestKey,
        data: currentRequest.key === requestKey ? currentRequest.data : [],
        hasLoaded: false,
        promise: requestPromise,
      };

      try {
        const reservations = await requestPromise;
        bookingIntelligenceRequest.current = {
          key: requestKey,
          data: reservations,
          hasLoaded: true,
          promise: null,
        };
        setBookingIntelligence(reservations);
        return reservations;
      } finally {
        if (
          bookingIntelligenceRequest.current.key === requestKey &&
          bookingIntelligenceRequest.current.promise === requestPromise
        ) {
          bookingIntelligenceRequest.current = {
            ...bookingIntelligenceRequest.current,
            promise: null,
          };
        }
        setLoading((loadingStatus) => loadingStatus - 1);
      }
    }, []);

    const getCommunicationIntelligence = useCallback(async (start, end) => {
      if (!start || !end) return { messages: [], automations: [] };

      const requestKey = `${moment(start).format("YYYY-MM-DD")}:${moment(end).format("YYYY-MM-DD")}`;
      const currentRequest = communicationIntelligenceRequest.current;

      if (currentRequest.key === requestKey) {
        if (currentRequest.promise) {
          return currentRequest.promise;
        }

        if (currentRequest.hasLoaded) {
          return currentRequest.data;
        }
      }

      setLoading((prev) => prev + 1);
      const requestPromise = ReportsService.getCommunicationIntelligence(start, end).then(
        (response) => ({
          messages: response.data?.messages || [],
          automations: response.data?.automations || [],
        }),
      );

      communicationIntelligenceRequest.current = {
        key: requestKey,
        data: currentRequest.key === requestKey ? currentRequest.data : { messages: [], automations: [] },
        hasLoaded: false,
        promise: requestPromise,
      };

      try {
        const data = await requestPromise;
        communicationIntelligenceRequest.current = {
          key: requestKey,
          data,
          hasLoaded: true,
          promise: null,
        };
        setCommunicationIntelligence(data);
        return data;
      } finally {
        if (
          communicationIntelligenceRequest.current.key === requestKey &&
          communicationIntelligenceRequest.current.promise === requestPromise
        ) {
          communicationIntelligenceRequest.current = {
            ...communicationIntelligenceRequest.current,
            promise: null,
          };
        }
        setLoading((loadingStatus) => loadingStatus - 1);
      }
    }, []);

    const searchAuditReservations = async (date, name) => {
      if (!date || !name) {
        setAuditReservations([]);
        return [];
      }

      setLoading((prev) => prev + 1);
      try {
        const data = await ReportsService.searchAuditReservations(date, name).then((response) => response.data);
        setAuditReservations(data);
        return data;
      } catch (err) {
        setAuditReservations([]);
        throw err;
      } finally {
        setLoading((loadingStatus) => loadingStatus - 1);
      }
    };

    const getMessageAudit = async (guestReservationId) => {
      if (!guestReservationId) {
        setMessageAudit([]);
        return [];
      }

      setLoading((prev) => prev + 1);
      try {
        const data = await ReportsService.getMessageAudit(guestReservationId).then((response) => response.data);
        setMessageAudit(data.audit || []);
        return data.audit || [];
      } catch (err) {
        setMessageAudit([]);
        return [];
      } finally {
        setLoading((loadingStatus) => loadingStatus - 1);
      }
    };

    const resetParams = () => {
      setPage(0);
      setFilter("");
    };

    let reportsCtx = {
      loading,
      overview,
      sms,
      email,
      guestbook,
      rental,
      history,
      guide,
      startDate,
      endDate,
      active,
      macros,
      fivestar,
      surveyReport,
      extendStay,
      guestChecks,
      extendstayChecks,
      webchats,
      extras,
      guestbookByDevice,
      guestbookByGuest,
      chatbotLogs,
      replyLogs,
      smartLockLogs,
      page,
      filter,
      orderDetails,
      incomeByItem,
      bookingSourceMapping,
      bookingIntelligence,
      communicationIntelligence,
      auditReservations,
      messageAudit,

      setActive,
      setPage,
      setFilter,
      setMacros,
      setFivestar,
      initReports,
      updateRange,
      getAutomatedSms,
      getAutomatedEmail,
      getGuide,
      getRental,
      getHistory,
      getGuestbook,
      getOverview,
      getMacros,
      getFiveStar,
      getSurveyReport,
      getExtendStay,
      getGuestChecks,
      getExtendStayChecks,
      getGuestBooksByDevice,
      getGuestBooksByGuest,
      getWebChat,
      getExtras,
      getChatbotLogs,
      getReplyLogs,
      getSmartLockLogs,
      resetParams,
      getOrderDetails,
      getIncomeByItem,
      getBookingSourceMapping,
      getBookingIntelligence,
      getCommunicationIntelligence,
      searchAuditReservations,
      getMessageAudit,
      setAuditReservations,
      setMessageAudit
    };

    return (
      <ReportsContext.Provider value={reportsCtx}>
        {children}
      </ReportsContext.Provider>
    );
  };
